export default {
  "Yes": "Đúng",
  "No": "Không",

  "Yes, I'm Sure": "Chắc Chắn",

  "Filter": "Lọc",
  "Record": "Dữ Liệu",
  "deletedData": "Dữ liệu đã được xóa thành công",
  "dataAdded": "Dữ liệu đã lưu thành công",
}
